import React, { FC } from "react";

import cn from "classnames";

import { GuideStatus } from "@mapmycustomers/shared";
import { GuideUserStatus } from "@mapmycustomers/shared/types/entity";

import styles from "./UserGuidesCompletion.module.scss";

export interface UserGuidesCompletionProps {
  statuses: GuideUserStatus[];
}

const UserGuidesCompletion: FC<UserGuidesCompletionProps> = ({ statuses }) => {
  const completedCount = statuses.filter(({ status }) => status === GuideStatus.COMPLETED).length;
  return (
    <div
      className={cn({
        [styles.allComplete]: completedCount === statuses.length && statuses.length > 0,
      })}
    >
      {statuses.length > 0 ? `${completedCount}/${statuses.length}` : "—"}
    </div>
  );
};

export default UserGuidesCompletion;
